import { GraphQLBoolean, GraphQLObjectType, GraphQLString } from 'graphql';

import { TypeNames } from '../../types';

const MyAvatar = new GraphQLObjectType({
	fields: {
		url: { type: GraphQLString },
		uploaded: { type: GraphQLBoolean },
	},
	name: TypeNames.MY_AVATAR,
	description: 'Get meta-data about current user’s avatar',
});

export default MyAvatar;
